import styled from '@emotion/styled'
import { MarketPlaceProperties } from '@pubstack/common/src/bidderCatalog'
import { FunctionComponent } from 'react'
import { Fonts } from '~/assets/style/fonts'
import Button from '~/components/Button'
import { Flyout } from '~/components/Flyout'
import { useGlobalModal } from '~/components/layout/GlobalModal'
import { normalizeAsTrackingLabel } from '~/components/layout/ProductTrackingIntegration'
import { Modal } from '~/components/Modal'
import { WithClassName } from '~/types/utils'
import { LegalInformation, PureMarketplaceLegalInfos } from './PureMarketplaceLegalInfos'

const Bloc = styled.div`
  padding-bottom: 20px;
  align-items: center;
  p { 
    ${Fonts.P1}
  }
  h2 {
    ${Fonts.H2}
    font-weight: 500;
    padding-bottom: 12px;
  }
`

const SeeLegalModal: FunctionComponent<{
  marketplaceProperties: MarketPlaceProperties
  bidderDisplayName: string
  bidderCode: string
}> = ({ marketplaceProperties, bidderDisplayName, bidderCode }) => {
  const { close } = useGlobalModal()

  return (
    <Modal.Content>
      <Modal.Title>{bidderDisplayName}: Legal information</Modal.Title>
      <Modal.Body>
        <LegalInformation marketplaceProperties={marketplaceProperties} />
      </Modal.Body>
      <Modal.Actions>
        <Button variant={'tertiary'} onClick={close} trackingLabel={`marketplace-legal-information-${normalizeAsTrackingLabel(bidderCode)}-close`}>
          Close
        </Button>
      </Modal.Actions>
    </Modal.Content>
  )
}

type PureMarketplaceLegalsFlyoutProps = WithClassName & {
  bidderCode: string
  bidderDisplayName: string
  marketplaceProperties: MarketPlaceProperties
}
const UnstyledPureMarketplaceLegalsFlyout: FunctionComponent<PureMarketplaceLegalsFlyoutProps> = ({ bidderCode, bidderDisplayName, marketplaceProperties }) => {
  const modal = useGlobalModal()
  return (
    <Flyout.Content>
      <Flyout.Title>Marketplace integration : {bidderDisplayName}</Flyout.Title>
      <Flyout.Body>
        <Bloc>
          <p>Using Marketplace allows you to focus on your inventory and strategy while Pubstack handles the rest : contract and billing parts, mapping,...</p>
          <p>You are just one click away from a super easy bidder management solution !</p>
        </Bloc>
        <h2>Legal information</h2>
        <PureMarketplaceLegalInfos
          marketplaceProperties={marketplaceProperties}
          bidderCode={bidderCode}
          onLegalInfosClick={() => modal.open(SeeLegalModal, { marketplaceProperties, bidderDisplayName, bidderCode })}
        />
      </Flyout.Body>
    </Flyout.Content>
  )
}

export const PureMarketplaceLegalsFlyout = styled(UnstyledPureMarketplaceLegalsFlyout)``
